// extracted by mini-css-extract-plugin
module.exports = {"subtitleWrap":"ProductSubtitle_subtitleWrap__27Iqv","subtitle":"ProductSubtitle_subtitle__oNoF8","dotted":"ProductSubtitle_dotted__2SpiR"};